import { render, staticRenderFns } from "./VisitYearDurationDescriptiveStatistics.vue?vue&type=template&id=3cbf8478&scoped=true"
import script from "./VisitYearDurationDescriptiveStatistics.vue?vue&type=script&lang=ts"
export * from "./VisitYearDurationDescriptiveStatistics.vue?vue&type=script&lang=ts"
import style0 from "./VisitYearDurationDescriptiveStatistics.vue?vue&type=style&index=0&id=3cbf8478&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbf8478",
  null
  
)

export default component.exports